import type { SendStatus } from '../../../types/studyTimeline';
import styles from './StudyCardAccession.module.css';

interface StudyCardAccessionProps {
  accessionNumber: string;
  orderNumber: string;
  referringPhysicianName: string;
  referringPhysicianDepartment: string;
  sendStatus: SendStatus | null;
}

const SEND_LABELS: Record<SendStatus, string> = {
  sent: 'Sent',
  not_sent: 'Not sent',
};

export default function StudyCardAccession({
  accessionNumber,
  orderNumber,
  referringPhysicianName,
  referringPhysicianDepartment,
  sendStatus,
}: StudyCardAccessionProps) {
  return (
    <div className={styles.row}>
      <span className={styles.mono}>Acc# {accessionNumber}</span>
      <span className={styles.separator}>·</span>
      <span className={styles.mono}>Ord# {orderNumber}</span>
      <span className={styles.separator}>·</span>
      <span>{referringPhysicianName}</span>
      {referringPhysicianDepartment && (
        <>
          <span className={styles.separator}>·</span>
          <span className={styles.dept}>{referringPhysicianDepartment}</span>
        </>
      )}
      {sendStatus && (
        <>
          <span className={styles.separator}>·</span>
          <span className={styles.sendStatus} data-status={sendStatus}>
            {SEND_LABELS[sendStatus]}
          </span>
        </>
      )}
    </div>
  );
}
